/**
 * @generated SignedSource<<1ef1a4f6d72354431a0db593a8f36135>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type companiesWithoutActiveSubscriptions_viewer$data = {
  readonly id: string;
  readonly actualPersonId: string | null;
  readonly missionControlData: {
    readonly id: string;
    readonly companiesWithoutActiveSubscriptions: ReadonlyArray<{
      readonly id: string;
      readonly companyId: number | null;
      readonly name: string | null;
      readonly tier: string | null;
      readonly createdAt: string | null;
      readonly updatedAt: string | null;
      readonly lastSessionDate: string | null;
      readonly isSagePSACompany: boolean | null;
      readonly salesforceAccountId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "companiesWithoutActiveSubscriptions_viewer";
};
export type companiesWithoutActiveSubscriptions_viewer$key = {
  readonly " $data"?: companiesWithoutActiveSubscriptions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"companiesWithoutActiveSubscriptions_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "companiesWithoutActiveSubscriptions_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlCompaniesWithoutActiveSubscriptionsType",
          "kind": "LinkedField",
          "name": "companiesWithoutActiveSubscriptions",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tier",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastSessionDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSagePSACompany",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "salesforceAccountId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "8a012c31a207b34cbc5aba2a2a9830c7";

export default node;
